import PropTypes from 'prop-types'
import React from 'react'
import ReactDOM from 'react-dom'
import Tether from 'react-tether'
import ResizeAware from 'react-resize-aware'
import { uncontrollable } from 'uncontrollable'
import classes from './ToggleModal.module.scss'

let zIndex = 1100

export class ToggleModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    attachment: PropTypes.string.isRequired,
    overlay: PropTypes.bool,
    backdrop: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    attachClickHandler: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    show: false,
    overlay: true,
    attachClickHandler: true,
    attachment: 'middle left',
    constraints: [
      {
        to: 'window',
        pin: true
      }
    ]
  }

  static optimizations = {
    gpu: false
  }

  constructor (props) {
    super(props)

    this.handleOverlayClick = this.handleOverlayClick.bind(this)
    this.handleChildClick = this.handleChildClick.bind(this)
    this.makeHandleMenuButtonClick = this.makeHandleMenuButtonClick.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.position = this.position.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.renderToggle = this.renderToggle.bind(this)
  }

  componentWillMount () {
    if (this.props.show) {
      zIndex += 10
      this._zIndex = zIndex
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.show && !this.props.show) {
      zIndex += 10
      this._zIndex = zIndex
    } else if (!nextProps.show && this.props.show) {
      zIndex -= 10
      this._zIndex = zIndex
    }
  }

  componentWillUnmount () {
    if (this.props.show) {
      zIndex -= 10
    }
  }

  handleOverlayClick (event) {
    event.stopPropagation()

    this.close()
  }

  handleChildClick (event) {
    event.stopPropagation()
  }

  makeHandleMenuButtonClick (menuButton) {
    const { onClick } = menuButton.props

    return (event, ...args) => {
      event.stopPropagation()

      onClick && onClick(event, ...args)

      this.props.onToggle(!this.props.show)
    }
  }

  open () {
    if (!this.props.show) {
      this.props.onToggle(true)
    }
  }

  close () {
    if (this.props.show) {
      this.props.onToggle(false)
    }
  }

  position () {
    this.tetherRef && this.tetherRef.position()
  }

  handleResize () {
    this.position()
  }

  renderToggle () {
    const {
      children,
      attachClickHandler
    } = this.props

    const firstChild = React.Children.toArray(children)[0]

    const props =
      attachClickHandler
      ? {
        onClick: this.makeHandleMenuButtonClick(firstChild)
      } : null

    return !firstChild ? null : React.cloneElement(firstChild, props)
  }

  render () {
    const {
      children,
      overlay,
      backdrop,
      show,
      onToggle,
      ...restProps
    } = this.props

    const secondChild = React.Children.toArray(children)[1]

    return (
      <React.Fragment>
        <Tether
          {...restProps}
          ref={(ref) => { this.tetherRef = ref }}
          optimizations={ToggleModal.optimizations}
          style={{
            zIndex: this._zIndex + 1
          }}
        >
          {this.renderToggle()}
          {show && 
            <ResizeAware
              onlyEvent
              style={{ position: 'relative' }}
              onResize={this.handleResize}
              onClick={this.handleChildClick}
            >
              {secondChild}
            </ResizeAware>
          }
        </Tether>
        {overlay && show && ReactDOM.createPortal(
          <div
            className={classes.overlay + (backdrop ? ' ' + classes.backdrop : '')}
            style={{
              zIndex: this._zIndex
            }}
            onClick={this.handleOverlayClick}
          />,
          document.body
        )}
      </React.Fragment>
    )
  }
}

export default uncontrollable(
  ToggleModal,
  {
    show: 'onToggle'
  },
  ['open', 'close', 'position']
)

